import ClientDashboard from "@pages/Client/Dashboard";
import ReimbursementDashboard from "@pages/Client/Reimbursement/Dashboard";
import ReimbursementDashboardEdit from "@pages/Client/Reimbursement/Dashboard/edit";
import ReimbursementView from "@pages/Client/Reimbursement/Dashboard/view";

export const ReimbursementRoutes = [
  {
    path: "/reimbursement/dashboard",
    name: "reimbursement_dashboard",
    component: ReimbursementDashboard,
  },

  {
    path: "/reimbursement/edit",
    name: "reimbursement_dashboard",
    component: ReimbursementDashboardEdit,
  },

  {
    path: "/reimbursement/view/:register_id",
    name: "reimbursement_dashboard",
    component: ReimbursementView,
  },
];
